module.exports = __webpack_public_path__ + "media/images/icon-resource-link-e0a680e800ff84e9a8654861656f28a4.png";